import { Type, Validator } from '@vista-digital/validator';
import { FieldFormatType } from './field-format-type';
import { passwordRuleValidator } from './password-rule';
export const textFieldValidationConfigValidatorSchema = {
    type: Validator.isEqualTo(FieldFormatType.Text),
    minLength: Validator.optional(Validator.number({ min: 0 })),
    maxLength: Validator.optional(Validator.number({ min: 1 })),
    format: Validator.optional(Validator.ofType(Type.RegExp)),
    required: Validator.boolean(),
    customValidation: Validator.optional(Validator.fn())
};
export const textFieldValidationConfigValidator = Validator.object(textFieldValidationConfigValidatorSchema);
export const emailFieldValidationConfigValidatorSchema = {
    type: Validator.isEqualTo(FieldFormatType.Email),
    required: Validator.boolean(),
    customValidation: Validator.optional(Validator.fn())
};
export const emailFieldValidationConfigValidator = Validator.object(emailFieldValidationConfigValidatorSchema);
export const numberFieldValidationConfigValidatorSchema = {
    type: Validator.isEqualTo(FieldFormatType.Number),
    minLength: Validator.optional(Validator.number({ min: 0 })),
    maxLength: Validator.optional(Validator.number({ min: 1 })),
    required: Validator.boolean(),
    customValidation: Validator.optional(Validator.fn())
};
export const numberFieldValidationConfigValidator = Validator.object(numberFieldValidationConfigValidatorSchema);
export const currencyFieldValidationConfigValidatorSchema = {
    type: Validator.isEqualTo(FieldFormatType.Currency),
    required: Validator.boolean()
};
export const currencyFieldValidationConfigValidator = Validator.object(currencyFieldValidationConfigValidatorSchema);
export const numberRangeValidatorSchema = Validator.optional(Validator.object({
    min: Validator.optional(Validator.number()),
    max: Validator.optional(Validator.number())
}));
export const decimalFieldValidationConfigValidatorSchema = {
    type: Validator.isEqualTo(FieldFormatType.Decimal),
    required: Validator.boolean(),
    customValidation: Validator.optional(Validator.fn()),
    range: numberRangeValidatorSchema
};
export const decimalFieldValidationConfigValidator = Validator.object(decimalFieldValidationConfigValidatorSchema);
export const integerFieldValidationConfigValidatorSchema = {
    type: Validator.isEqualTo(FieldFormatType.Integer),
    required: Validator.boolean(),
    customValidation: Validator.optional(Validator.fn()),
    range: numberRangeValidatorSchema
};
export const integerFieldValidationConfigValidator = Validator.object(integerFieldValidationConfigValidatorSchema);
export const dateFieldValidationConfigValidatorSchema = {
    type: Validator.isEqualTo(FieldFormatType.Date),
    minAge: Validator.optional(Validator.number({ min: 0 })),
    required: Validator.boolean(),
    customValidation: Validator.optional(Validator.fn())
};
export const dateFieldValidationConfigValidator = Validator.object(dateFieldValidationConfigValidatorSchema);
export const otherFieldValidationConfigValidatorSchema = {
    type: Validator.isEqualTo(FieldFormatType.Other),
    required: Validator.boolean(),
    customValidation: Validator.optional(Validator.fn())
};
export const otherFieldValidationConfigValidator = Validator.object(otherFieldValidationConfigValidatorSchema);
export const passwordFieldConfigValidatorSchema = {
    type: Validator.isEqualTo(FieldFormatType.Password),
    minLength: Validator.optional(Validator.number({ min: 0 })),
    maxLength: Validator.number({ min: 1, max: 64 }),
    required: Validator.boolean(),
    rules: Validator.array({ items: passwordRuleValidator }),
    customValidation: Validator.optional(Validator.fn())
};
export const passwordFieldConfigValidator = Validator.object(passwordFieldConfigValidatorSchema);
//# sourceMappingURL=field-validation-config.js.map